import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import { ElementPropertyType } from '../../../models/element-property.model';
import { ElementKind } from '../../../models/project.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
  IConditionalNode,
} from '../../../helpers/conditional-nodes.helpers';
import {
  mapResults,
  getQuantityPropertyLabel,
  isA5EnergyKwhDisplaySbefCode,
  isA5SbefCode,
} from './energy.helpers';
import { ProductID } from '../../../models/product.model';
import {
  DEFAULT_ENERGY_PRODUCT_ID,
  ENERGY_PROPERTY_PRODUCTS_NAME,
  energyProductSelectOptions,
  energyProducts,
} from './energy.model';
import { EXPRESSION_VARIABLE_NAME } from '@shared/constants/expression-variables-names.constant';
import { sbefCodeProperty } from '../common-element-category-properties.model';
import { PIECES_QUANTITY_FACTORY } from '../../../models/element-quantities.model';

const productIds: IConditionalNode<ProductID> = {
  property: ENERGY_PROPERTY_PRODUCTS_NAME,
  // Select `count` is the generic product id; map keys must match resolved count.
  map: energyProducts.reduce<Record<string, ProductID>>(
    (acc, { id }) => ({ ...acc, [id]: id }),
    {},
  ),
};

export const energy: IElementCategory = {
  id: ElementCategoryID.Energy,
  name: 'Energy',
  color: 'rgba(255, 197, 2, 1)',
  defaultSelectedQuantity: 'energy',
  disableQuantitySelection: true,
  properties: [
    {
      name: ENERGY_PROPERTY_PRODUCTS_NAME,
      type: ElementPropertyType.Select,
      count: DEFAULT_ENERGY_PRODUCT_ID,
      options: energyProductSelectOptions,
    },
    sbefCodeProperty,
  ],

  mapResults,
  getQuantityPropertyLabel,

  getQuantityProperties: (el) => ({
    energy: {
      displayUnit:
        el && !isA5EnergyKwhDisplaySbefCode(el) ? 'kWh/yr' : undefined,
    },
    pieces: { ...PIECES_QUANTITY_FACTORY },
  }),
  // `throwIfNotFound: false` + `undefined` return: tolerate transient Select
  // counts (e.g. a deprecated energy product id). Returning `undefined`
  // tells the caller to skip enrichment so existing children survive.
  getChildElements: (element) => {
    const productId = getValueFromConditionalNodes(
      element,
      [productIds],
      false,
    );
    if (!productId) return undefined;
    return [
      {
        kind: ElementKind.Product,
        unit: 'kWh',
        // Make energy annual if it is not a A5 sbef
        count: isA5SbefCode(element)
          ? 'energy'
          : `energy * ${EXPRESSION_VARIABLE_NAME.BUILDING_LIFETIME}`,
        product_id: productId,
      },
    ];
  },
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, productIds),
};
